import { render } from "./AddLinkModal.vue?vue&type=template&id=8f59b83e&scoped=true"
import script from "./AddLinkModal.vue?vue&type=script&lang=js"
export * from "./AddLinkModal.vue?vue&type=script&lang=js"

import "./AddLinkModal.vue?vue&type=style&index=0&id=8f59b83e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f59b83e"]])

export default __exports__